// Adjusted hook: hooks/requests/customer/use-get-customer-platforms.ts

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ICustomerPlatform } from "@/interfaces/customer-platform.interfaces";
import customerPlatformService from "@/services/customer-platform.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseGetCustomerPlatformsReturn = RequestsBaseReturn<ICustomerPlatform[] | null>;

export interface UseGetCustomerPlatformsProps {
  customerId: string | null;
}

const useGetCustomerPlatforms = ({
  customerId,
}: UseGetCustomerPlatformsProps): UseGetCustomerPlatformsReturn => {
  const shouldFetch = !!customerId;

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<ICustomerPlatform[], Error>(
    shouldFetch ? [SWR_KEYS.getCustomerPlatforms, customerId] : null,
    () => customerPlatformService.getAll(),
    { revalidateOnFocus: false }
  );

  return { data, isLoading, error };
};

export default useGetCustomerPlatforms;
